
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ConfigUpdateRequest} from './ConfigUpdateRequest';
import {FieldModelConfigUpdateRequest} from './ConfigUpdateRequest';
import {TradingRouteRuleModifyResponse} from './TradingRouteRuleModifyResponse';
import {TradingRouteRequestType} from '../core/TradingRouteRequestType';
import {FieldModelTradingRouteRequestType} from '../core/TradingRouteRequestType';
import {TradingRouteCondition} from '../core/TradingRouteCondition';
import {FieldModelTradingRouteCondition} from '../core/TradingRouteCondition';
import {TradingRouteActionDelay} from '../core/TradingRouteActionDelay';
import {FieldModelTradingRouteActionDelay} from '../core/TradingRouteActionDelay';
import {TradingRouteActionType} from '../core/TradingRouteActionType';
import {FieldModelTradingRouteActionType} from '../core/TradingRouteActionType';
import {TradingRouteActionForwardToGateway} from '../core/TradingRouteActionForwardToGateway';
import {FieldModelTradingRouteActionForwardToGateway} from '../core/TradingRouteActionForwardToGateway';

/**
 * TradingRouteRuleModifyRequest struct
 */
class TradingRouteRuleModifyRequest extends ConfigUpdateRequest {
  /**
   * Initialize struct
   * @param {!ConfigUpdateRequest=} parent
   * @param {!UUID=} ruleId
   * @param {boolean=} newIsEnabled
   * @param {string=} newName
   * @param {string=} newDescription
   * @param {!Set=} newRequestType
   * @param {!boolean=} requestTypeReset
   * @param {!Array=} newCondition
   * @param {!boolean=} conditionReset
   * @param {TradingRouteActionDelay=} newActionDelay
   * @param {!boolean=} newActionDelayReset
   * @param {TradingRouteActionType=} newActionType
   * @param {TradingRouteActionForwardToGateway=} newActionForwardToGateway
   * @param {!boolean=} newActionForwardToGatewayReset
   * @param {number=} newSortOrder
   * @param {string=} newGatewayAccountId
   * @param {!boolean=} newGatewayAccountIdReset
   * @constructor
   */
  constructor (parent = new ConfigUpdateRequest(), ruleId = new UUID(), newIsEnabled = null, newName = null, newDescription = null, newRequestType = new Set(), requestTypeReset = false, newCondition = [], conditionReset = false, newActionDelay = null, newActionDelayReset = false, newActionType = null, newActionForwardToGateway = null, newActionForwardToGatewayReset = false, newSortOrder = null, newGatewayAccountId = null, newGatewayAccountIdReset = false) {
    super()
    super.copy(parent)
    this.RuleId = ruleId
    this.NewIsEnabled = newIsEnabled
    this.NewName = newName
    this.NewDescription = newDescription
    this.NewRequestType = newRequestType
    this.RequestTypeReset = requestTypeReset
    this.NewCondition = newCondition
    this.ConditionReset = conditionReset
    this.NewActionDelay = newActionDelay
    this.NewActionDelayReset = newActionDelayReset
    this.NewActionType = newActionType
    this.NewActionForwardToGateway = newActionForwardToGateway
    this.NewActionForwardToGatewayReset = newActionForwardToGatewayReset
    this.NewSortOrder = newSortOrder
    this.NewGatewayAccountId = newGatewayAccountId
    this.NewGatewayAccountIdReset = newGatewayAccountIdReset
  }

  /**
   * Copy struct (shallow copy)
   * @this {!TradingRouteRuleModifyRequest}
   * @param {!TradingRouteRuleModifyRequest} other Other struct
   * @returns {!TradingRouteRuleModifyRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.RuleId != null) {
      this.RuleId = new UUID(other.RuleId)
    } else {
      this.RuleId = null
    }
    if (other.NewIsEnabled != null) {
      this.NewIsEnabled = other.NewIsEnabled
    } else {
      this.NewIsEnabled = null
    }
    if (other.NewName != null) {
      this.NewName = other.NewName
    } else {
      this.NewName = null
    }
    if (other.NewDescription != null) {
      this.NewDescription = other.NewDescription
    } else {
      this.NewDescription = null
    }
    if (other.NewRequestType != null) {
      this.NewRequestType = new Set()
      for (let item of other.NewRequestType) {
        if (item != null) {
          let tempItem
          tempItem = TradingRouteRequestType.fromObject(item)
          this.NewRequestType.add(tempItem)
        } else {
          this.NewRequestType.add(null)
        }
      }
    } else {
      this.NewRequestType = null
    }
    if (other.RequestTypeReset != null) {
      this.RequestTypeReset = other.RequestTypeReset
    } else {
      this.RequestTypeReset = null
    }
    if (other.NewCondition != null) {
      this.NewCondition = []
      for (let item of other.NewCondition) {
        if (item != null) {
          let tempItem
          tempItem = TradingRouteCondition.fromObject(item)
          this.NewCondition.push(tempItem)
        } else {
          this.NewCondition.push(null)
        }
      }
    } else {
      this.NewCondition = null
    }
    if (other.ConditionReset != null) {
      this.ConditionReset = other.ConditionReset
    } else {
      this.ConditionReset = null
    }
    if (other.NewActionDelay != null) {
      this.NewActionDelay = TradingRouteActionDelay.fromObject(other.NewActionDelay)
    } else {
      this.NewActionDelay = null
    }
    if (other.NewActionDelayReset != null) {
      this.NewActionDelayReset = other.NewActionDelayReset
    } else {
      this.NewActionDelayReset = null
    }
    if (other.NewActionType != null) {
      this.NewActionType = TradingRouteActionType.fromObject(other.NewActionType)
    } else {
      this.NewActionType = null
    }
    if (other.NewActionForwardToGateway != null) {
      this.NewActionForwardToGateway = TradingRouteActionForwardToGateway.fromObject(other.NewActionForwardToGateway)
    } else {
      this.NewActionForwardToGateway = null
    }
    if (other.NewActionForwardToGatewayReset != null) {
      this.NewActionForwardToGatewayReset = other.NewActionForwardToGatewayReset
    } else {
      this.NewActionForwardToGatewayReset = null
    }
    if (other.NewSortOrder != null) {
      this.NewSortOrder = other.NewSortOrder
    } else {
      this.NewSortOrder = null
    }
    if (other.NewGatewayAccountId != null) {
      this.NewGatewayAccountId = other.NewGatewayAccountId
    } else {
      this.NewGatewayAccountId = null
    }
    if (other.NewGatewayAccountIdReset != null) {
      this.NewGatewayAccountIdReset = other.NewGatewayAccountIdReset
    } else {
      this.NewGatewayAccountIdReset = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!TradingRouteRuleModifyRequest}
   * @returns {!TradingRouteRuleModifyRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new TradingRouteRuleModifyRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new TradingRouteRuleModifyRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!TradingRouteRuleModifyRequest}
   * @param {!TradingRouteRuleModifyRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TradingRouteRuleModifyRequest)) {
      throw new TypeError('Instance of TradingRouteRuleModifyRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!TradingRouteRuleModifyRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      RuleId: ((this.RuleId != null) ? this.RuleId.toString() : null),
      NewIsEnabled: ((this.NewIsEnabled != null) ? this.NewIsEnabled : null),
      NewName: ((this.NewName != null) ? this.NewName : null),
      NewDescription: ((this.NewDescription != null) ? this.NewDescription : null),
      NewRequestType: ((this.NewRequestType != null) ? Array.from(this.NewRequestType, item => ((item != null) ? item : null)) : null),
      RequestTypeReset: ((this.RequestTypeReset != null) ? this.RequestTypeReset : null),
      NewCondition: ((this.NewCondition != null) ? Array.from(this.NewCondition, item => ((item != null) ? item : null)) : null),
      ConditionReset: ((this.ConditionReset != null) ? this.ConditionReset : null),
      NewActionDelay: ((this.NewActionDelay != null) ? this.NewActionDelay : null),
      NewActionDelayReset: ((this.NewActionDelayReset != null) ? this.NewActionDelayReset : null),
      NewActionType: ((this.NewActionType != null) ? this.NewActionType : null),
      NewActionForwardToGateway: ((this.NewActionForwardToGateway != null) ? this.NewActionForwardToGateway : null),
      NewActionForwardToGatewayReset: ((this.NewActionForwardToGatewayReset != null) ? this.NewActionForwardToGatewayReset : null),
      NewSortOrder: ((this.NewSortOrder != null) ? this.NewSortOrder : null),
      NewGatewayAccountId: ((this.NewGatewayAccountId != null) ? this.NewGatewayAccountId : null),
      NewGatewayAccountIdReset: ((this.NewGatewayAccountIdReset != null) ? this.NewGatewayAccountIdReset : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return TradingRouteRuleModifyRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!TradingRouteRuleModifyRequest} other Object value
   * @returns {!TradingRouteRuleModifyRequest} Created struct
   */
  static fromObject (other) {
    return new TradingRouteRuleModifyRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!TradingRouteRuleModifyRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return TradingRouteRuleModifyRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!TradingRouteRuleModifyRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6310
  }
}

export { TradingRouteRuleModifyRequest };

/**
 * Fast Binary Encoding TradingRouteRuleModifyRequest field model
 */
class FieldModelTradingRouteRuleModifyRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelConfigUpdateRequest(buffer, 4 + 4)
    this.RuleId = new fbe.FieldModelUUID(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.NewIsEnabled = new fbe.FieldModelOptional(new fbe.FieldModelBool(buffer, this.RuleId.fbeOffset + this.RuleId.fbeSize), buffer, this.RuleId.fbeOffset + this.RuleId.fbeSize)
    this.NewName = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.NewIsEnabled.fbeOffset + this.NewIsEnabled.fbeSize), buffer, this.NewIsEnabled.fbeOffset + this.NewIsEnabled.fbeSize)
    this.NewDescription = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.NewName.fbeOffset + this.NewName.fbeSize), buffer, this.NewName.fbeOffset + this.NewName.fbeSize)
    this.NewRequestType = new fbe.FieldModelSet(new FieldModelTradingRouteRequestType(buffer, this.NewDescription.fbeOffset + this.NewDescription.fbeSize), buffer, this.NewDescription.fbeOffset + this.NewDescription.fbeSize)
    this.RequestTypeReset = new fbe.FieldModelBool(buffer, this.NewRequestType.fbeOffset + this.NewRequestType.fbeSize)
    this.NewCondition = new fbe.FieldModelVector(new FieldModelTradingRouteCondition(buffer, this.RequestTypeReset.fbeOffset + this.RequestTypeReset.fbeSize), buffer, this.RequestTypeReset.fbeOffset + this.RequestTypeReset.fbeSize)
    this.ConditionReset = new fbe.FieldModelBool(buffer, this.NewCondition.fbeOffset + this.NewCondition.fbeSize)
    this.NewActionDelay = new fbe.FieldModelOptional(new FieldModelTradingRouteActionDelay(buffer, this.ConditionReset.fbeOffset + this.ConditionReset.fbeSize), buffer, this.ConditionReset.fbeOffset + this.ConditionReset.fbeSize)
    this.NewActionDelayReset = new fbe.FieldModelBool(buffer, this.NewActionDelay.fbeOffset + this.NewActionDelay.fbeSize)
    this.NewActionType = new fbe.FieldModelOptional(new FieldModelTradingRouteActionType(buffer, this.NewActionDelayReset.fbeOffset + this.NewActionDelayReset.fbeSize), buffer, this.NewActionDelayReset.fbeOffset + this.NewActionDelayReset.fbeSize)
    this.NewActionForwardToGateway = new fbe.FieldModelOptional(new FieldModelTradingRouteActionForwardToGateway(buffer, this.NewActionType.fbeOffset + this.NewActionType.fbeSize), buffer, this.NewActionType.fbeOffset + this.NewActionType.fbeSize)
    this.NewActionForwardToGatewayReset = new fbe.FieldModelBool(buffer, this.NewActionForwardToGateway.fbeOffset + this.NewActionForwardToGateway.fbeSize)
    this.NewSortOrder = new fbe.FieldModelOptional(new fbe.FieldModelUInt32(buffer, this.NewActionForwardToGatewayReset.fbeOffset + this.NewActionForwardToGatewayReset.fbeSize), buffer, this.NewActionForwardToGatewayReset.fbeOffset + this.NewActionForwardToGatewayReset.fbeSize)
    this.NewGatewayAccountId = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.NewSortOrder.fbeOffset + this.NewSortOrder.fbeSize), buffer, this.NewSortOrder.fbeOffset + this.NewSortOrder.fbeSize)
    this.NewGatewayAccountIdReset = new fbe.FieldModelBool(buffer, this.NewGatewayAccountId.fbeOffset + this.NewGatewayAccountId.fbeSize)
  }

  /**
   * Get the ConfigUpdateRequest field model
   * @this {!FieldModelTradingRouteRuleModifyRequest}
   * @returns {!FieldModelConfigUpdateRequest} ConfigUpdateRequest field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelTradingRouteRuleModifyRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelTradingRouteRuleModifyRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.RuleId.fbeSize + this.NewIsEnabled.fbeSize + this.NewName.fbeSize + this.NewDescription.fbeSize + this.NewRequestType.fbeSize + this.RequestTypeReset.fbeSize + this.NewCondition.fbeSize + this.ConditionReset.fbeSize + this.NewActionDelay.fbeSize + this.NewActionDelayReset.fbeSize + this.NewActionType.fbeSize + this.NewActionForwardToGateway.fbeSize + this.NewActionForwardToGatewayReset.fbeSize + this.NewSortOrder.fbeSize + this.NewGatewayAccountId.fbeSize + this.NewGatewayAccountIdReset.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelTradingRouteRuleModifyRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.RuleId.fbeExtra + this.NewIsEnabled.fbeExtra + this.NewName.fbeExtra + this.NewDescription.fbeExtra + this.NewRequestType.fbeExtra + this.RequestTypeReset.fbeExtra + this.NewCondition.fbeExtra + this.ConditionReset.fbeExtra + this.NewActionDelay.fbeExtra + this.NewActionDelayReset.fbeExtra + this.NewActionType.fbeExtra + this.NewActionForwardToGateway.fbeExtra + this.NewActionForwardToGatewayReset.fbeExtra + this.NewSortOrder.fbeExtra + this.NewGatewayAccountId.fbeExtra + this.NewGatewayAccountIdReset.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelTradingRouteRuleModifyRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelTradingRouteRuleModifyRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelTradingRouteRuleModifyRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6310
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelTradingRouteRuleModifyRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelTradingRouteRuleModifyRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.RuleId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RuleId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RuleId.fbeSize

    if ((fbeCurrentSize + this.NewIsEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewIsEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewIsEnabled.fbeSize

    if ((fbeCurrentSize + this.NewName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewName.fbeSize

    if ((fbeCurrentSize + this.NewDescription.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewDescription.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDescription.fbeSize

    if ((fbeCurrentSize + this.NewRequestType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewRequestType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewRequestType.fbeSize

    if ((fbeCurrentSize + this.RequestTypeReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RequestTypeReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestTypeReset.fbeSize

    if ((fbeCurrentSize + this.NewCondition.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewCondition.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewCondition.fbeSize

    if ((fbeCurrentSize + this.ConditionReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ConditionReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ConditionReset.fbeSize

    if ((fbeCurrentSize + this.NewActionDelay.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewActionDelay.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewActionDelay.fbeSize

    if ((fbeCurrentSize + this.NewActionDelayReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewActionDelayReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewActionDelayReset.fbeSize

    if ((fbeCurrentSize + this.NewActionType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewActionType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewActionType.fbeSize

    if ((fbeCurrentSize + this.NewActionForwardToGateway.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewActionForwardToGateway.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewActionForwardToGateway.fbeSize

    if ((fbeCurrentSize + this.NewActionForwardToGatewayReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewActionForwardToGatewayReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewActionForwardToGatewayReset.fbeSize

    if ((fbeCurrentSize + this.NewSortOrder.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewSortOrder.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSortOrder.fbeSize

    if ((fbeCurrentSize + this.NewGatewayAccountId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewGatewayAccountId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewGatewayAccountId.fbeSize

    if ((fbeCurrentSize + this.NewGatewayAccountIdReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewGatewayAccountIdReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewGatewayAccountIdReset.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelTradingRouteRuleModifyRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelTradingRouteRuleModifyRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelTradingRouteRuleModifyRequest}
   * @param {!TradingRouteRuleModifyRequest} fbeValue Default value, defaults is new TradingRouteRuleModifyRequest()
   * @returns {!TradingRouteRuleModifyRequest} TradingRouteRuleModifyRequest value
   */
  get (fbeValue = new TradingRouteRuleModifyRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelTradingRouteRuleModifyRequest}
   * @param {!TradingRouteRuleModifyRequest} fbeValue TradingRouteRuleModifyRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.RuleId.fbeSize) <= fbeStructSize) {
      fbeValue.RuleId = this.RuleId.get()
    } else {
      fbeValue.RuleId = new UUID()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RuleId.fbeSize

    if ((fbeCurrentSize + this.NewIsEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.NewIsEnabled = this.NewIsEnabled.get()
    } else {
      fbeValue.NewIsEnabled = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewIsEnabled.fbeSize

    if ((fbeCurrentSize + this.NewName.fbeSize) <= fbeStructSize) {
      fbeValue.NewName = this.NewName.get()
    } else {
      fbeValue.NewName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewName.fbeSize

    if ((fbeCurrentSize + this.NewDescription.fbeSize) <= fbeStructSize) {
      fbeValue.NewDescription = this.NewDescription.get()
    } else {
      fbeValue.NewDescription = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDescription.fbeSize

    if ((fbeCurrentSize + this.NewRequestType.fbeSize) <= fbeStructSize) {
      this.NewRequestType.get(fbeValue.NewRequestType)
    } else {
      fbeValue.NewRequestType.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewRequestType.fbeSize

    if ((fbeCurrentSize + this.RequestTypeReset.fbeSize) <= fbeStructSize) {
      fbeValue.RequestTypeReset = this.RequestTypeReset.get()
    } else {
      fbeValue.RequestTypeReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestTypeReset.fbeSize

    if ((fbeCurrentSize + this.NewCondition.fbeSize) <= fbeStructSize) {
      this.NewCondition.get(fbeValue.NewCondition)
    } else {
      fbeValue.NewCondition.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewCondition.fbeSize

    if ((fbeCurrentSize + this.ConditionReset.fbeSize) <= fbeStructSize) {
      fbeValue.ConditionReset = this.ConditionReset.get()
    } else {
      fbeValue.ConditionReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ConditionReset.fbeSize

    if ((fbeCurrentSize + this.NewActionDelay.fbeSize) <= fbeStructSize) {
      fbeValue.NewActionDelay = this.NewActionDelay.get()
    } else {
      fbeValue.NewActionDelay = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewActionDelay.fbeSize

    if ((fbeCurrentSize + this.NewActionDelayReset.fbeSize) <= fbeStructSize) {
      fbeValue.NewActionDelayReset = this.NewActionDelayReset.get()
    } else {
      fbeValue.NewActionDelayReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewActionDelayReset.fbeSize

    if ((fbeCurrentSize + this.NewActionType.fbeSize) <= fbeStructSize) {
      fbeValue.NewActionType = this.NewActionType.get()
    } else {
      fbeValue.NewActionType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewActionType.fbeSize

    if ((fbeCurrentSize + this.NewActionForwardToGateway.fbeSize) <= fbeStructSize) {
      fbeValue.NewActionForwardToGateway = this.NewActionForwardToGateway.get()
    } else {
      fbeValue.NewActionForwardToGateway = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewActionForwardToGateway.fbeSize

    if ((fbeCurrentSize + this.NewActionForwardToGatewayReset.fbeSize) <= fbeStructSize) {
      fbeValue.NewActionForwardToGatewayReset = this.NewActionForwardToGatewayReset.get()
    } else {
      fbeValue.NewActionForwardToGatewayReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewActionForwardToGatewayReset.fbeSize

    if ((fbeCurrentSize + this.NewSortOrder.fbeSize) <= fbeStructSize) {
      fbeValue.NewSortOrder = this.NewSortOrder.get()
    } else {
      fbeValue.NewSortOrder = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSortOrder.fbeSize

    if ((fbeCurrentSize + this.NewGatewayAccountId.fbeSize) <= fbeStructSize) {
      fbeValue.NewGatewayAccountId = this.NewGatewayAccountId.get()
    } else {
      fbeValue.NewGatewayAccountId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewGatewayAccountId.fbeSize

    if ((fbeCurrentSize + this.NewGatewayAccountIdReset.fbeSize) <= fbeStructSize) {
      fbeValue.NewGatewayAccountIdReset = this.NewGatewayAccountIdReset.get()
    } else {
      fbeValue.NewGatewayAccountIdReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewGatewayAccountIdReset.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelTradingRouteRuleModifyRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelTradingRouteRuleModifyRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelTradingRouteRuleModifyRequest}
   * @param {!TradingRouteRuleModifyRequest} fbeValue TradingRouteRuleModifyRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelTradingRouteRuleModifyRequest}
   * @param {TradingRouteRuleModifyRequest} fbeValue TradingRouteRuleModifyRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.RuleId.set(fbeValue.RuleId)
    this.NewIsEnabled.set(fbeValue.NewIsEnabled)
    this.NewName.set(fbeValue.NewName)
    this.NewDescription.set(fbeValue.NewDescription)
    this.NewRequestType.set(fbeValue.NewRequestType)
    this.RequestTypeReset.set(fbeValue.RequestTypeReset)
    this.NewCondition.set(fbeValue.NewCondition)
    this.ConditionReset.set(fbeValue.ConditionReset)
    this.NewActionDelay.set(fbeValue.NewActionDelay)
    this.NewActionDelayReset.set(fbeValue.NewActionDelayReset)
    this.NewActionType.set(fbeValue.NewActionType)
    this.NewActionForwardToGateway.set(fbeValue.NewActionForwardToGateway)
    this.NewActionForwardToGatewayReset.set(fbeValue.NewActionForwardToGatewayReset)
    this.NewSortOrder.set(fbeValue.NewSortOrder)
    this.NewGatewayAccountId.set(fbeValue.NewGatewayAccountId)
    this.NewGatewayAccountIdReset.set(fbeValue.NewGatewayAccountIdReset)
  }
}

export { FieldModelTradingRouteRuleModifyRequest };

/**
 * Fast Binary Encoding TradingRouteRuleModifyRequest model
 */
class TradingRouteRuleModifyRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelTradingRouteRuleModifyRequest(this.buffer, 4)
  }

  /**
   * Get the TradingRouteRuleModifyRequest model
   * @this {!TradingRouteRuleModifyRequestModel}
   * @returns {!FieldModelTradingRouteRuleModifyRequest} model TradingRouteRuleModifyRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!TradingRouteRuleModifyRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!TradingRouteRuleModifyRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return TradingRouteRuleModifyRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!TradingRouteRuleModifyRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelTradingRouteRuleModifyRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!TradingRouteRuleModifyRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!TradingRouteRuleModifyRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!TradingRouteRuleModifyRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!TradingRouteRuleModifyRequestModel}
   * @param {!TradingRouteRuleModifyRequest} value TradingRouteRuleModifyRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!TradingRouteRuleModifyRequestModel}
   * @param {!TradingRouteRuleModifyRequest} value TradingRouteRuleModifyRequest value, defaults is new TradingRouteRuleModifyRequest()
   * @return {!object} Deserialized TradingRouteRuleModifyRequest value and its size
   */
  deserialize (value = new TradingRouteRuleModifyRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new TradingRouteRuleModifyRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new TradingRouteRuleModifyRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!TradingRouteRuleModifyRequestModel}
   * @param {!number} prev Previous TradingRouteRuleModifyRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { TradingRouteRuleModifyRequestModel };
TradingRouteRuleModifyRequest.__has_response = true;
TradingRouteRuleModifyRequest.__response_class = TradingRouteRuleModifyResponse;
